import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-12 col-md-4" }
const _hoisted_3 = { class: "col-12 col-md-4" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["value", "onBlur", "onFocus"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Укажите дату ", -1)
const _hoisted_7 = { class: "col-12 col-md-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Поставщик:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "НДС:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("p", { class: "lead" }, "Материалы")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-3 border" }, " Название ТМЦ "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-1 border" }, " Ед изм "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border" }, " Количество "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border" }, " Цена за единицу "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border" }, " Выберите материал "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-2 border" }, " Количество ")
], -1)
const _hoisted_13 = { class: "col-3 border" }
const _hoisted_14 = { class: "col-1 border" }
const _hoisted_15 = { class: "col-2 border" }
const _hoisted_16 = { class: "col-2 border" }
const _hoisted_17 = { class: "col-2 border d-flex align-items-center" }
const _hoisted_18 = { class: "col-2 border d-flex align-items-center" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-xl",
    title: "Добавление накладной ТМЦ"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, { label: "Номер" }, {
              default: _withCtx(() => [
                _createVNode(_component_input_ui, {
                  modelValue: _ctx.state.number,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.number) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите дату",
              label: "Дата",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.state.date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.date) = $event)),
                  class: "inline-block h-full",
                  is24hr: true,
                  mode: "date"
                }, {
                  default: _withCtx(({ inputValue, togglePopover }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("input", {
                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.isDateError && _ctx.state.visibleErrors, 'bg-white': true }]),
                        as: "",
                        readonly: "",
                        timezone: 'Asia/Dhaka',
                        value: inputValue,
                        onBlur: ($event: any) => (togglePopover()),
                        onFocus: ($event: any) => (togglePopover())
                      }, null, 42, _hoisted_5),
                      _hoisted_6
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.state.contractorName), 1),
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.state.isVatIncludedInPrice ? 'Да' : 'Нет'), 1)
          ]),
          _hoisted_11,
          _hoisted_12,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.materials, (material) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 row",
              key: material.id
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Укажите наименование ТМЦ",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_input_ui, {
                      class: "mt-2",
                      placeholder: "Наименование ТМЦ",
                      modelValue: material.originalName,
                      "onUpdate:modelValue": ($event: any) => ((material.originalName) = $event),
                      "is-invalid": _ctx.isNameError(material) && _ctx.state.visibleErrors
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Укажите единицу измерения",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_input_ui, {
                      class: "mt-2",
                      modelValue: material.originalUnitDimension,
                      "onUpdate:modelValue": ($event: any) => ((material.originalUnitDimension) = $event),
                      placeholder: "Ед изм",
                      "is-invalid": _ctx.isUnitError(material) && _ctx.state.visibleErrors
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Укажите количество ТМЦ",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_input_ui, {
                      class: "mt-2",
                      type: "number",
                      step: "any",
                      modelValue: material.originalCount,
                      "onUpdate:modelValue": ($event: any) => ((material.originalCount) = $event),
                      placeholder: "Количество ТМЦ",
                      "is-invalid": _ctx.isCountInvError(material) && _ctx.state.visibleErrors
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_form_group_ui, {
                  "invalid-feedback": "Укажите цену",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_input_ui, {
                      class: "mt-2",
                      modelValue: material.originalUnitPrice,
                      "onUpdate:modelValue": ($event: any) => ((material.originalUnitPrice) = $event),
                      step: "any",
                      type: "number",
                      placeholder: "Цена за единицу",
                      "is-invalid": _ctx.isSumInvError(material) && _ctx.state.visibleErrors
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(material.materialName), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(material.actualCount) + " " + _toDisplayString(material.unit), 1),
              _createElementVNode("div", _hoisted_19, [
                _createTextVNode(" Общая сумма материала: " + _toDisplayString(_ctx.formatMoney(material.total)) + " (без НДС: " + _toDisplayString(_ctx.formatMoney(_ctx.state.isVatIncludedInPrice ?
                        material.total / 1.12 : material.total)) + ") ", 1),
                (_ctx.isTotalSumError(material) && _ctx.state.visibleErrors)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Общая сумма материала не бьется с количеством или ценой "))
                  : _createCommentVNode("", true),
                _hoisted_21
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id"]))
}